/**
 * The training spots (render/trainingSpots.ts): their scenery joins each camera angle's props, their
 * falling water moves on before the scenery is drawn, and their ambience rises over the world.
 */
import { settings } from '../../settings';
import type { Ground } from '../terrain';
import { SpotScenery } from '../trainingSpots';
import { registerRenderPass } from './registry';

/** Each camera angle's spots, by that angle's ground. */
const spotsOf = new WeakMap<Ground, SpotScenery>();

registerRenderPass({
  id: 'spotWater',
  layer: 'ground',
  order: 500,
  scenery(v) {
    const spots = new SpotScenery(v.map, v.origin, v.view);
    spotsOf.set(v.ground, spots);
    return spots.props;
  },
  draw(f) {
    if (f.outdoors) spotsOf.get(f.outdoors.ground)?.animate(f.world.time);
  },
});

registerRenderPass({
  id: 'spotAmbience',
  layer: 'world',
  order: 500,
  draw(f) {
    if (settings.ambience && !f.scene && f.outdoors)
      spotsOf.get(f.outdoors.ground)?.draw(f.g, f.ox, f.oy, f.W, f.H, f.world.time);
  },
});
